import './card-chart.scss';
import {
	CategoryScale,
	Chart,
	LineController,
	LineElement,
	LinearScale,
	PointElement,
	Tooltip,
} from 'chart.js';

export default () => {
	// Dots
	const dots = document.querySelectorAll( '.js-dots' );

	dots.forEach( ( dot ) => {
		dot.addEventListener( 'click', () => dot.classList.toggle( 'is-active' ) );
	} );

	window.addEventListener( 'click', function ( e ) {
		const current = e.target.closest( '.card-chart__dot-items' );

		dots.forEach( ( dot ) => {
			current !== dot.closest( '.card-chart__dot-items' ) && dot.classList.remove( 'is-active' );
		} );
	} );

	// Register required Chart.js components
	Chart.register( LineController, LineElement, PointElement, LinearScale, CategoryScale, Tooltip );

	// Colors and number of bands
	const bandColors = [
		'rgba(81, 76, 196, 0.24)',
		'rgba(255, 186, 0, 0.24)',
		'rgba(0, 154, 181, 0.24)',
		'rgba(157, 230, 140, 0.24)',
		'rgba(223, 66, 69, 0.24)',
	];
	const numberOfBands = 5;

	// Create plugin instance
	const horizontalBandsPlugin = createHorizontalBandsPlugin( bandColors, numberOfBands );

	// Horizontal Bands Plugin Factory
	function createHorizontalBandsPlugin ( colors, numberOfBands ) {
		return {
			id: 'horizontalBandsBackground',
			beforeDatasetsDraw ( chart ) {
				if ( chart.ctx.canvas.id !== 'quadrantLineChart' ) {
					return;
				}

				const {
					ctx,
					chartArea,
				} = chart;

				if ( !chartArea ) {
					return;
				}

				ctx.save();
				const {
					left,
					right,
					top,
					bottom,
				} = chartArea;
				const chartHeight = bottom - top;
				const bandHeight = chartHeight / numberOfBands;

				for ( let i = 0;i < numberOfBands;i++ ) {
					ctx.fillStyle = colors[ i % colors.length ];
					const y = top + i * bandHeight;

					ctx.fillRect( left, y, right - left, bandHeight );
				}

				ctx.restore();
			},
		};
	}

	// Register plugin globally
	Chart.register( horizontalBandsPlugin );

	// Create the chart
	const ctx = document.getElementById( 'quadrantLineChart' ).getContext( '2d' );

	new Chart( ctx, {
		type: 'line',
		data: {
			datasets: [ {
				label: 'My Line Dataset',
				data: [
					{
						x: 0.5,
						y: 0,
					},
					{
						x: 1,
						y: 0.8,
					},
					{
						x: 2,
						y: 1.2,
					},
					{
						x: 5,
						y: 1.1,
					},
					{
						x: 6,
						y: 1.6,
					},
					{
						x: 7,
						y: 2,
					},
					{
						x: 8,
						y: 1.2,
					},
					{
						x: 9,
						y: 1.4,
					},
					{
						x: 10,
						y: 2.1,
					},
					{
						x: 11,
						y: 1.2,
					},
					{
						x: 13,
						y: 2.4,
					},
					{
						x: 14,
						y: 2.5,
					},
					{
						x: 15,
						y: 2,
					},
					{
						x: 16,
						y: 2.7,
					},
					{
						x: 17,
						y: 2.8,
					},
					{
						x: 18,
						y: 2.9,
					},
					{
						x: 19,
						y: 4,
					},
					{
						x: 20,
						y: 3.2,
					},
					{
						x: 21,
						y: 3.6,
					},
					{
						x: 22,
						y: 3.7,
					},
					{
						x: 23,
						y: 3.8,
					},
					{
						x: 24,
						y: 3.9,
					},
					{
						x: 25,
						y: 3,
					},
					{
						x: 26,
						y: 4.1,
					},
					{
						x: 27,
						y: 4.2,
					},
					{
						x: 28,
						y: 4.3,
					},
					{
						x: 29,
						y: 4.4,
					},
					{
						x: 30,
						y: 4.5,
					},
				],
				borderColor: '#000',
				tension: 0.1,
				fill: false,
				pointRadius: 0,
				borderWidth: 2,
			} ],
		},
		options: {
			responsive: true,
			maintainAspectRatio: false,
			scales: {
				x: {
					type: 'linear',
					min: 1,
					max: 30,
					position: 'bottom',
					title: {
						display: true,
						text: 'Dates',
						font: {
							size: 12,
							weight: 'medium',
						},
						color: '#000',
					},
					ticks: {
						stepSize: 1,
					},
				},
				y: {
					type: 'linear',
					min: 1,
					max: 5,
					beginAtZero: true,
					title: {
						display: true,
						text: 'Quality of life score',
						font: {
							size: 12,
							weight: 'medium',
						},
						color: '#000',
					},
					ticks: {
						stepSize: 1,
					},
				},
			},
		},
		plugins: [ horizontalBandsPlugin ],
	} );
};
